import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState();

  const [isFetching, setIsFetching] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser === undefined) {
      const storedUser = localStorage.getItem("user");
      if (storedUser !== null && storedUser !== "undefined") {
        setCurrentUser(JSON.parse(storedUser));
      }
    }

    setIsFetching(false);
  }, [currentUser]);

  async function login(data) {
    const serverResponse = await fetch(
      "https://api.redfoxcafe.ir/v1/user/login",
      {
        method: "POST",
        body: JSON.stringify(data),
      }
    ).then((response) => response.json());

    if (serverResponse && serverResponse.status === "200") {
      setCurrentUser(serverResponse.data);
      localStorage.setItem("user", JSON.stringify(serverResponse.data));
      return serverResponse;
    } else {
      throw serverResponse.message;
    }
  }

  async function signup(data) {
    const serverResponse = await fetch(
      "https://api.redfoxcafe.ir/v1/user/signup",
      {
        method: "POST",
        body: JSON.stringify(data),
      }
    ).then((response) => response.json());

    if (serverResponse && serverResponse.status === "200") {
      setCurrentUser(serverResponse.data);
      localStorage.setItem("user", JSON.stringify(serverResponse.data));
      return serverResponse;
    } else {
      throw serverResponse.message;
    }
  }

  async function updateInfo(data) {
    await fetch("https://api.redfoxcafe.ir/v1/client/update-client-info/", {
      method: "POST",
      headers: {
        "Authorization-Token": "Bearer " + currentUser.access_token,
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((d) => {
        if (d.status === "200") {
          const newData = {
            ...currentUser,
            mobile: data.phone,
            name: data.name,
          };
          setCurrentUser(newData);

          localStorage.setItem("user", JSON.stringify(newData));
        } else if (d.status === "401") {
          logout();
          navigate("/login", { replace: true });
        } else {
          throw new Error(d.message);
        }
      });
  }

  async function logout() {
    localStorage.removeItem("user");
    setCurrentUser(null);
  }

  async function changePassword(data) {
    await fetch("https://api.redfoxcafe.ir/v1/client/change-password/", {
      method: "POST",
      headers: {
        "Authorization-Token": "Bearer " + currentUser.access_token,
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((d) => {
        if (d.status === "200") {
          return;
        } else if (d.status === "401") {
          logout();
          navigate("/login", { replace: true });
        } else {
          throw new Error(d.message);
        }
      })
      .catch((err) => {
        throw err;
      });
  }

  const info = {
    currentUser,
    login,
    signup,
    updateInfo,
    logout,
    changePassword,
  };

  return (
    <AuthContext.Provider value={info}>
      {isFetching ? null : children}
    </AuthContext.Provider>
  );
}
